exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VehicleList .Summary .Table {\r\n\twidth: 100%;\r\n\tmargin-top: 10px;\r\n\tfont-size: 11px;\r\n}\r\n\r\n.VehicleList .Summary .Table tr{\r\n\tline-height: 15px;\r\n}\r\n\r\n.VehicleList .Summary .Table td:nth-child(1){\r\n\ttext-align: right;\r\n\tfont-weight: bold;\r\n\twidth: 175px;\r\n}\r\n\r\n.VehicleList .Summary .Table td:nth-child(2){\r\n\ttext-align: left;\r\n\tpadding-left: 10px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/view/VehicleList/Summary/Table/Table.css
// module id = 739
// module chunks = 0